






















import Vue from 'vue';

interface ICustomButtonData {
  toggled: boolean;
}

export default Vue.extend({
  name: `CustomButton`,
  data(): ICustomButtonData {
    return {
      toggled: false,
    };
  },
  computed: {
    showIcon(): string {
      return this.toggled && this.toggleIcon ? this.toggleIcon : this.icon;
    },
    showText(): string {
      return this.toggled && this.toggleText ? this.toggleText : this.text;
    },
  },
  props: {
    contentCenterOverride: {
      type: Boolean,
      default: false,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    icon: {
      default: null,
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    mode: {
      default: `light`,
      type: String,
    },
    text: {
      default: null,
      type: String,
    },
    toggleIcon: {
      default: null,
      type: String,
    },
    toggleText: {
      default: null,
      type: String,
    },
  },
  methods: {
    clicked(): void {
      this.toggled = !this.toggled;
      this.$emit(`click`);
    },
  },
});
